import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { t } from '@lib/translation/helpers/translation.helper';

@Injectable({ providedIn: 'root' })
export class AiAPI {
  constructor(private readonly _http: HttpClient, private readonly _toastrService: ToastrService) {}

  public snapAi(data: any): Observable<any> {
    return this._http.post('/api/snap-api/detect/', data).pipe(
      tap({
        error: () => {
          this._toastrService.error(t('ai.errors.snapFailure'));
        },
      }),
    );
  }
}
